var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('area',{ref:"area",attrs:{"shape":"rect","coords":_vm.coords,"href":_vm.link}})}
var staticRenderFns = []

export { render, staticRenderFns }